import { transform } from 'lodash';

export function bindActions(actions: $TSFixMe, dispatch: $TSFixMe) {
    return transform(
        actions,
        (acc, action, key) => {
            acc[key] = bindAction(action, dispatch);
        },
        {}
    );
}

function bindAction(action: $TSFixMe, dispatch: $TSFixMe) {
    return (...args: $TSFixMe[]) => dispatch(action(...args));
}
